// import vendorService from "@/api/vendorService";
// import router from '@/router/index';

const state = {

    profileData: { name: "Alexandra", userName: "alex123", pswd: "1234", phNo: "+9123213461", email: "alex@gmail.com", addr: "addr 1", reportTo: "Chris vas", facility: "bangalore", job: "Software Engineer", depart: "Software engineer", empCode: "1010" },
    newVendor: '',
    editId: null
}
const getters = {
    Profile: state => state.profileData,

};

const actions = {
    async getProfile({ commit }, data) {

        commit('get', data)
    },

    async updateProfile({ commit }, data) {

        commit('update', data)
    },

}
const mutations = {
    get(state, data) {
        state.profileData = data
    },

    update(state, data) {
        state.profileData = data
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}